import { Context } from '@nuxt/types/app'
import { Middleware } from '@nuxt/types'
import MeUseCase from '@/usecases/auth/GetMeUseCase'
import menus from '@/assets/menu'

export const route: Middleware = ({ App, route, from }: Context) => {
  // 一つ前のルートを保存して、保存されている場合はそのページに戻る
  App.state.from = from.name !== route.name ? from.fullPath : null
  // ルートを取ってきて設定されているメニューと一致しているかを判定
  App.state.current = menus.find((prop) => prop?.id === route.name)
}

export const authenticated: Middleware = ({ App, route, redirect }: Context) => {
  // リダイレクト先を保存
  App.state.redirect = route.fullPath

  if (!App.auth.token) {
    redirect('/login')
  }
}

export const me: Middleware = async ({ App, error }: Context) => {
  if (!App.doctor.current) {
    await new MeUseCase(App).execute()
  }

  // chatgptはフラグによって表示するしないが決定
  if (App.state.current?.id === 'chatgpt' && !App.hospital.current?.flags?.chatgpt) {
    error({ statusCode: 404, message: 'Page not found' })
  }

  // ユーザーロールによって見れないページのときは404を出す
  const role = App.doctor.current?.flags.superuser ? 'superuser' : App.doctor.current?.role
  if (App.state.current?.policy && !App.state.current?.policy.includes(role || 'admin')) {
    error({ statusCode: 404, message: 'Page not found' })
  }
}
